import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileSaverService } from 'ngx-filesaver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { FileHandle } from 'src/app/shared/directives/drag-drop.directive';
import { Purpose } from 'src/app/shared/models/purpose.model';
import { Image } from 'src/app/shared/models/image.model';
import { Title } from 'src/app/shared/models/title.model';
import { LoadingImagesService } from '../loading-images/loading-images.service';
import { ResolutionAssignListService } from '../resolutions/resolution-assign-list/resolution-assign-list.service';

@Component({
  selector: 'app-search-titles',
  templateUrl: './search-titles.component.html',
  styleUrls: ['./search-titles.component.scss']
})
export class SearchTitlesComponent implements OnInit {

  files: FileHandle[];
  fileList: File[];
  titles: Title[];
  filterForm: FormGroup;
  purposes: Purpose[];
  formats: Image[];
  currenDate: Date;

  private purposesSubscription: Subscription = null;

  constructor(private fileSaverService: FileSaverService,
    private loadingImagesService: LoadingImagesService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private loader: NgxSpinnerService,
    private spinner: NgxSpinnerService,
    private resolutionListService: ResolutionAssignListService) { }

  ngOnInit() {
    this.files = [];
    this.fileList = [];
    this.purposes = [];
    this.formats = [];
    this.currenDate = new Date();

    this.filterForm = this.formBuilder.group({
      stock_id: [''],
      purpose_id: [''],
      format: ['']
    });

    this.getPurposes();
    this.getFormats();
  }

  /**
 *
 */
  getPurposes() {
    this.spinner.show();
    this.purposesSubscription = this.resolutionListService.getPurposes().subscribe((result: Purpose[]) => {
      this.purposes = result;
      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      console.error(error.message);
    });
  }


  /**
 *
 */
  getFormats() {
    this.spinner.show();
    this.purposesSubscription = this.resolutionListService.getFormats().subscribe((result: Image[]) => {
      this.formats = result;
      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      console.error(error.message);
    });
  }

  filesDropped(files: FileHandle[]): void {
    this.files = files;
  }

  downloadFile(): void {

    this.loader.show();

    let purpose = this.filterForm.get('purpose_id').value;
    let format = this.filterForm.get('format').value;

    if (this.files.length !== 0) {

      for (let i in this.files) {
        this.fileList.push(this.files[i].file);
      }

      this.loadingImagesService.uploadFileURLSDownloadFile(this.fileList, purpose, format).subscribe((response: any) => {

        // this.titles = response;
        this.files = [];
        this.filterForm.reset();

        this.loader.hide();

        this.fileSaverService.save(response, 'docURL' + '_' + this.currenDate.toLocaleDateString() + '.txt');

      }, (error) => {
        this.fileSaverService.save(error, 'docURL' + '_' + this.currenDate.toLocaleDateString() + '.txt');
        console.error(error);
        console.log(error);
        this.filterForm.reset();
        this.files = [];
        this.loader.hide();
        this.toastr.error(`Ha ocurrido un error al guardar la imagen, ${error}`, 'Error');
      });

    }

  }

  uploadData(): void {

    this.loader.show();

    let purpose = this.filterForm.get('purpose_id').value;
    let format = this.filterForm.get('format').value;

    if (this.files.length !== 0) {

      for (let i in this.files) {
        this.fileList.push(this.files[i].file);
      }

      this.loadingImagesService.uploadFileURLS(this.fileList, purpose, format).subscribe((response: any) => {

        this.titles = response;
        this.files = [];
        this.filterForm.reset();

        this.loader.hide();

      }, (error) => {
        console.error(error);
        console.log(error);
        this.filterForm.reset();
        this.files = [];
        this.loader.hide();
        this.toastr.error(`Ha ocurrido un error al guardar la imagen, ${error}`, 'Error');
      });

    }

  }

}
